import { get } from 'lodash';
import React from 'react';
import { EnumFieldType } from 'src/components/FieldModal/config';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import TagGroup from 'src/components/TagGroup/TagGroup';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
import { handleOnGetStoreTimezoneUTC } from 'src/tools/tools';
import { fieldValueGenerator } from '../../tools';

const colWidth = {
  [EnumFieldType.CustomerID]: { width: { fixedWidth: 240 } },
  [EnumFieldType.RegisteredDate]: { width: { minWidth: 200 } },
  [EnumFieldType.RegisteredSalesChannel]: { width: { minWidth: 280 } },
  [EnumFieldType.AccountCreatedDate]: { width: { minWidth: 200 } },
  [EnumFieldType.TotalOrderAmount]: { width: { minWidth: 200 } },
  [EnumFieldType.TotalOrderNumber]: { width: { minWidth: 200 } },
  [EnumFieldType.AverageOrderAmount]: { width: { minWidth: 216 } },
  [EnumFieldType.LastOrderAmount]: { width: { minWidth: 200 } },
  [EnumFieldType.Email]: { width: { minWidth: 200 } },
  [EnumFieldType.MobileNumber]: { width: { minWidth: 200 } },
  [EnumFieldType.FirstName]: { width: { minWidth: 140 } },
  [EnumFieldType.LastName]: { width: { minWidth: 140 } },
  [EnumFieldType.FullName]: { width: { minWidth: 200 } },
  [EnumFieldType.CrossBorderName]: { width: { minWidth: 200 } },
  [EnumFieldType.DateOfBirth]: { width: { minWidth: 140 } },
  [EnumFieldType.Gender]: { width: { minWidth: 140 } },
  [EnumFieldType.Title]: { width: { minWidth: 80 } },
  [EnumFieldType.Language]: { width: { minWidth: 280 } },
  [EnumFieldType.CustomerRemarks]: { width: { minWidth: 200 } },
  [EnumFieldType.CustomerManualTags]: { width: { minWidth: 280 } },
  [EnumFieldType.CustomerAutoTags]: { width: { minWidth: 280 } },
  [EnumFieldType.ConsentAttribute]: { width: { minWidth: 280 } },
  [EnumFieldType.SubscriptionStatus]: { width: { minWidth: 160 } },
};

const tagDict = [
  EnumFieldType.CustomerManualTags,
  EnumFieldType.CustomerAutoTags,
];

const useCols = (fields, onView, { getI18n }) => {
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();
  const a = fields.map((i) => {
    const { field, defaultShow, mustShow, sortable } = i || {};

    const { name, uuid, fieldType } = field || {};
    if (name === 'Mobile Number') return {}; // UXPSA-12964
    const width = (colWidth[fieldType] || {}).width || { minWidth: 200 };
    const _isTag = tagDict.includes(fieldType);
    const formatName =
      name === 'SubscribedDate' ? `${name} (UTC ${timezoneInUTC})` : name;
    return {
      ...width,
      key: name,
      default: defaultShow,
      sorter: sortable,
      sortOrder: '',
      optional: !mustShow,
      textTitle: formatName,
      titleGenerate: () => (
        <NoWrapContainer>
          <Tooltip title={formatName}>{formatName}</Tooltip>
        </NoWrapContainer>
      ),

      // title: name,
      tags: _isTag,
      //  {..._isTag?{}:{childGenerate:}}
      ...(_isTag
        ? {
            tagsGenerator: (
              characterLength,
              width,
              marginPaddingWidth,
              containPaddingWidth,
              tags,
              record,
            ) => {
              const customerInfoFields =
                get(record, 'customerInfoFields') ||
                get(record, 'fields') ||
                [];
              const field = customerInfoFields.find((i) => {
                const uid = get(i, 'field.uuid');
                return uid === uuid;
              });

              const value = get(field, 'value') || get(field, 'values') || [];

              const _tags = value.map((i) => {
                return { name: i };
              });
              return (
                <TagGroup
                  characterLength={characterLength}
                  containerWidth={width}
                  marginPaddingWidth={marginPaddingWidth}
                  containPaddingWidth={containPaddingWidth}
                  tags={_tags}
                />
              );
            },
          }
        : {
            childGenerate: (_, record) => {
              const customerInfoFields =
                get(record, 'customerInfoFields') ||
                get(record, 'fields') ||
                [];

              const field = customerInfoFields.find((i) => {
                const uid = get(i, 'field.uuid');
                return uid === uuid;
              });
              //  console.log('field', field);
              const _field = get(field, 'field') || {};
              const _fieldName = _field?.name || '';

              const value = get(field, 'value') || get(field, 'values') || [];

              const display = value.length > 0 ? value.join(' ') : '-';

              return (
                <NoWrapContainer>
                  <Tooltip title={display}>
                    {fieldValueGenerator(
                      _fieldName,
                      customerInfoFields,
                      display,
                    )}
                  </Tooltip>
                </NoWrapContainer>
              );
            },
          }),

      // childGenerate: (_, record) => {
      //   const customerInfoFields =
      //     get(record, 'customerInfoFields') || get(record, 'fields') || [];

      //   const field = customerInfoFields.find((i) => {
      //     const uid = get(i, 'field.uuid');
      //     return uid === uuid;
      //   });
      //   console.log('field', field);

      //   const value = get(field, 'value') || get(field, 'values') || [];

      //   const display = value.length > 0 ? value.join(' ') : '-';

      //   return (
      //     <NoWrapContainer>
      //       <Tooltip title={display}>{display}</Tooltip>
      //     </NoWrapContainer>
      //   );
      // },
    };
  });
  const re = [
    ...a,
    {
      titleGenerate: () => getI18n('customerTag.customerTag_List.actions'),
      position: EnumTablePosition.mid,
      key: 'Actions',
      default: true,
      childGenerate: (url, record, index) => {
        const { uuid } = record;
        return (
          <Actions
            editText={getI18n('general.view')}
            onEdit={() => {
              if (onView) {
                onView(uuid);
              }
              //  remove(index);
            }}
          />
        );
      },
      fixedWidth: 190,
    },
  ];
  //console.log('col', a);
  return re;
};
export { useCols };
